var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require("@/assets/images/logo/logo-dark.png"),"width":"120px","height":"120px","alt":"Ferman Logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }